(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('MailExplorerRedirectToPolicy', ["routeHelper", "$routeParams", "policyDao", function (routeHelper, $routeParams, policyDao) {
        var moduleToPolicyTemplateId = {
            office365_emails: 'office365_emails_emails_explorer',
            google_mail: 'google_mail_email_explorer'
        };
        function redirectToPolicyCatalog() {
            var mailExplorerTemplate = {};
            var templateId = moduleToPolicyTemplateId[$routeParams.module] || 'office365_emails_emails_explorer';
            policyDao.getTemplates().then(function (response) {
                _(response.data.templates).each(function (row) {
                    if (row.policy.policy_desc.templateId === templateId) {
                        mailExplorerTemplate = row;
                    }
                });
                mailExplorerTemplate.policy.policy_desc.name = mailExplorerTemplate.template_name;
                mailExplorerTemplate.policy.policy_data = mailExplorerTemplate.policy.policy_desc;
                mailExplorerTemplate.policy.context = { saas: 'office365_emails' };
                mailExplorerTemplate.policy.policy_name = '';
                mailExplorerTemplate.policy.temporary = true;
                mailExplorerTemplate.policy.policy_status = 'running';
                policyDao.create(mailExplorerTemplate.policy).then(function (response) {
                    var url = routeHelper.getHref('policy-edit', { id: response.data.policy_id });
                    window.location.href = url;
                });
            });
        }
        redirectToPolicyCatalog();
    }]);
    m.controller('MailExplorerOld', ["$q", "$scope", "$rootScope", "$timeout", "tablePaginationHelper", "defaultListConverter", "apAvananExceptionsDao", "mailExplorerDao", "$routeParams", "modals", "manualActionDao", "modulesManager", "apAvananAddBlacklistModal", "routeHelper", "policyDao", function ($q, $scope, $rootScope, $timeout, tablePaginationHelper, defaultListConverter, apAvananExceptionsDao, mailExplorerDao, $routeParams, modals, manualActionDao, modulesManager, apAvananAddBlacklistModal, routeHelper, policyDao) {
        $scope.loading = true;
        $scope.error = '';
        $scope.params = [];
        $scope.loaded = false;
        $scope.model = { currentModule: $routeParams.module };
        $scope.emptySearch = true;
        $scope.updateSearchStatus = function () {
            var isEmptySearch = true;
            $scope.params.forEach(function (param) {
                if (param.id != 'fromDate' && param.id != 'toDate') {
                    if (param.data) {
                        isEmptySearch = false;
                        return;
                    }
                }
            });
            $scope.emptySearch = isEmptySearch;
        };
        var availableSaases = ['office365_emails'];
        modulesManager.init().then(function () {
            $scope.enabledSaases = _(modulesManager.activeSaasApps()).filter(function (saas) {
                return _(availableSaases).contains(saas.name);
            });
        });
        var currentModule = $routeParams.module;
        var moduleToEntityType = {
            google_mail: 'google_mail_email',
            office365_emails: 'office365_emails_email'
        };
        var actionName = {
            quarantine: {
                google_mail: {
                    attributes: { email: '{google_mail_email}' },
                    name: 'google_mail_email_quarantine'
                },
                office365_emails: {
                    attributes: { email: '{office365_emails_email}' },
                    name: 'office365_emails_email_quarantine'
                }
            }
        };
        function displayBlacklistModal() {
            if (!isFormValid()) {
                return modals.confirm({
                    message: _($scope.errorsList).join('<br>'),
                    title: 'Illegal Input',
                    cancelText: null
                });
            }
            var blacklistRule = {};
            var params = [];
            var sum = '';
            _($scope.params).chain().map(function (param) {
                if (!param.enabled || !param.isBlacklistCondition) {
                    return;
                }
                params.push({
                    type: 'message',
                    message: '#' + JSON.stringify({
                        display: 'html',
                        text: '<strong>' + param.label + '</strong>' + ': ' + param.data
                    })
                });
                blacklistRule[param.id] = param.data;
            });
            if (blacklistRule.subject) {
                blacklistRule.subject_matching = 'contains';
            }
            if (params.length === 0) {
                return modals.params([{
                        lastPage: true,
                        hideDefaultButton: true,
                        label: 'Please select filter scope',
                        params: [
                            {
                                type: 'message',
                                message: 'Blacklist rule can not be empty!'
                            },
                            {
                                type: 'message',
                                message: 'Please insert data in the different critirias in order to create a blacklist rule.'
                            }
                        ]
                    }], 'Create blacklist rule').then(function (data) {
                });
            }
            params.unshift({
                type: 'message',
                message: 'You are about to create a blacklist rule for the following critirias:'
            });
            params.push({
                id: 'do_not_include_existing',
                type: 'boolean',
                rightLabel: 'Do not include existing emails'
            });
            return modals.params([{
                    lastPage: true,
                    okButton: 'Create Blacklist Rule',
                    hideDefaultButton: true,
                    label: 'Please select filter scope',
                    params: params
                }], 'Create blacklist rule').then(function (data) {
                blacklistRule.match_only_future = data.do_not_include_existing;
                return apAvananExceptionsDao.blacklistCreate(blacklistRule);
            });
        }
        function simpleTooltipConverter(text) {
            return '#' + JSON.stringify({
                display: 'text',
                text: text,
                tooltip: {
                    content: { text: text },
                    position: {
                        my: 'bottom center',
                        at: 'top center'
                    },
                    style: {
                        classes: 'qtip-standard ap-avanan-blacklist-tip',
                        def: false
                    }
                }
            });
        }
        $scope.options = {
            columns: [],
            options: {
                defaultOrdering: {
                    columnName: 'received_at',
                    order: 'desc'
                },
                checkboxes: true
            },
            entityType: moduleToEntityType[currentModule]
        };
        $scope.tableOptions = {
            disableTop: true,
            resetSelectedOnPageChange: true,
            orderDisplayMode: 'highlight-column',
            allowedPageSizes: [
                20,
                50
            ],
            asDivs: true,
            reloadUuid: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            pagesAround: 2,
            pagination: {
                pageSize: 50,
                ordering: {}
            },
            dropdownHeader: true
        };
        $scope.blacklist = function () {
            displayBlacklistModal();
        };
        $scope.quarantine = function () {
            var selected = $scope.tableHelper && $scope.tableHelper.getSelectedIds();
            if (!selected || !selected.length) {
                return modals.alert('No emails selected. Please select at least one email.', {
                    title: 'No emails selected',
                    closeText: 'Ok'
                });
            }
            return modals.confirm({
                message: 'Are you sure you want to Quarantine the selected ' + selected.length + ' emails?',
                title: 'Quarantine Action',
                okText: 'Quarantine'
            }).then(function () {
                manualActionDao.create($scope.options.entityType, selected, angular.copy(actionName.quarantine[currentModule])).then(function () {
                    // Refresh table 
                    return modals.confirm({
                        message: 'Action successful! It might take a few moments to update.',
                        title: 'Quarantine Successful!',
                        okText: 'Ok',
                        cancelText: null
                    }).then(function () {
                        $scope.refreshTable();
                    }, function () {
                        $scope.refreshTable();
                    });
                });
            });
        };
        var standardColumns = [
            {
                id: 'entity_id',
                hidden: true,
                primary: true
            },
            {
                id: 'entity_type',
                hidden: true
            },
            {
                id: 'recipients',
                text: 'Recipients',
                converter: 'listConverter',
                converterArgs: {
                    elementAsTooltip: true,
                    moreInPopup: true,
                    expanded: 10,
                    collapseRest: true,
                    countPostfix: 'recipients'
                }
            },
            {
                id: 'received_at',
                text: 'Received',
                converter: GMTtoLocalTimeConverter,
                format: 'time'
            }
        ];
        var params = [
            {
                id: 'fromDate',
                hiddenInTable: true,
                type: 'datetime',
                order: 1,
                data: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
                // 2 = number of days back
                label: 'From (exact)'
            },
            {
                id: 'toDate',
                hiddenInTable: true,
                type: 'datetime',
                order: 2,
                data: new Date(),
                label: 'To'
            },
            {
                id: 'subject',
                isBlacklistCondition: true,
                type: 'string',
                converter: EntityProfileLinkConverter,
                order: 3,
                data: '',
                label: 'Subject (contains)'
            },
            {
                id: 'nickname',
                isBlacklistCondition: true,
                type: 'string',
                order: 4,
                data: '',
                label: 'Sender Name (contains)'
            },
            {
                id: 'sender_ip',
                isBlacklistCondition: true,
                type: 'string',
                order: 5,
                data: '',
                label: 'Sender IP (SMTP) (exact)',
                validation: {
                    regexp: {
                        value: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))$/,
                        message: 'Please provide a valid Sender SMTP IP address'
                    }
                }
            },
            {
                id: 'sender_client_ip',
                isBlacklistCondition: true,
                type: 'string',
                order: 6,
                data: '',
                label: 'Client Sender IP (exact)',
                validation: {
                    regexp: {
                        value: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))$/,
                        message: 'Please provide a valid Sender client IP address'
                    }
                }
            },
            {
                id: 'sender_address',
                isBlacklistCondition: true,
                type: 'string',
                order: 7,
                data: '',
                label: 'Sender Email (exact)'
            },
            {
                id: 'sender_domain_suffix',
                isBlacklistCondition: true,
                type: 'string',
                order: 8,
                data: '',
                label: 'Sender Domain (exact)'
            },
            {
                id: 'is_deleted_message',
                hidden: true,
                type: 'boolean',
                enabled: true,
                order: 9,
                data: false,
                label: 'Show deleted'
            },
            {
                id: 'is_quarantined',
                hidden: true,
                type: 'boolean',
                enabled: true,
                order: 10,
                data: false,
                label: 'Show quarantined'
            }
        ];
        $scope.$on('blacklist-open-modal', function (event, data) {
            return displayBlacklistModal(event, data);
        });
        $scope.params = _(params).chain().sortBy('order').value();
        $scope.options.columns = _($scope.params).chain().reject(function (param) {
            return param.id === 'sender_domain_suffix' || param.hidden || param.hiddenInTable;
        }).map(function (param) {
            return {
                id: param.id,
                text: param.label,
                validation: param.validation,
                converter: param.converter || simpleTooltipConverter,
                hiddenInForm: param.hiddenInForm
            };
        }).value().concat(standardColumns);
        $scope.loading = false;
        $scope.loaded = true;
        var queryFilters = null;
        var refreshDelay = null;
        function makeFilters() {
            var newData = _($scope.params).chain().map(function (param) {
                if (param.type === 'datetime') {
                    return [
                        param.id,
                        moment(param.data).utc().format()
                    ];
                }
                if (param.enabled && param.data) {
                    return [
                        param.id,
                        param.data
                    ];
                }
                if (param.hidden) {
                    return [
                        param.id,
                        param.data
                    ];
                }
            }).compact().object().value();
            return newData;
        }
        function isFormValid() {
            var isValid = true;
            $scope.errorsList = [];
            $scope.params.forEach(function (param) {
                if (param.validation) {
                    if (param.validation.required) {
                        if (param.data === '') {
                            $scope.errorsList.push(param.validation.required.message);
                            isValid = false;
                            return;
                        }
                    } else {
                        if (param.data === '') {
                            return;
                        }
                    }
                    if (param.validation.regexp && param.validation.regexp.value) {
                        var patt = new RegExp(param.validation.regexp.value);
                        if (!patt.test(param.data)) {
                            isValid = false;
                            $scope.errorsList.push(param.validation.regexp.message);
                            return;
                        }
                    }
                }
            });
            return isValid;
        }
        $scope.refreshTable = function () {
            if (!isFormValid()) {
                return modals.confirm({
                    message: _($scope.errorsList).join('<br>'),
                    title: 'Illegal Input',
                    cancelText: null
                });
            }
            if ($scope.tableHelper) {
                $scope.tableHelper.reload();
            } else {
                initTable();
            }
        };
        function initTable() {
            $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                var q;
                queryFilters = makeFilters();
                if ($scope.mode === 'rule') {
                    q = apAvananExceptionsDao.blacklistItem(options.blacklistId);
                } else {
                    q = mailExplorerDao.searchEmails(queryFilters);
                }
                $scope.error = '';
                return q.pagination(args.offset, args.limit).converter(defaultListConverter, { columns: $scope.options.columns }).onRequestFail(function (error) {
                    if (error.status === 400 && error.data && error.data.message) {
                        $scope.error = error.data.message;
                        return $q.when({
                            data: {
                                rows: [],
                                total_rows: 0
                            }
                        });
                    } else {
                        return $q.reject(error);
                    }
                });
            }, function (tableModel) {
                $scope.tableModel = tableModel;
                $scope.totalEmails = $scope.tableHelper.getTotal();
            });
        }
        function EntityProfileLinkConverter(text, columnId, event, args) {
            var url = routeHelper.getHref('profile', {
                entityType: event.entity_type,
                id: event.entity_id
            });
            url += '?hide_menu=1';
            var link = '#' + JSON.stringify({
                display: 'html',
                // href: url,
                text: '<a href="' + url + '" class="display-block white-space-nowrap action-link" target="_blank">' + (event[columnId] || 'N/A') + '</a>'
            });
            return link;
        }
        function GMTtoLocalTimeConverter(text, columnId, event, args) {
            return moment.utc(text).local().format('LL') + ' ' + moment.utc(text).local().format('LTS');
        }
    }]);
}());